import { useCurrentUser } from '@cma/app'
import { Button, Menu } from '@cma/common'
import { getAccessTokens } from '@cma/features/auth'
import { HelixIcon } from '@helix/helix-icon'
import { document_csv as DocumentCSVIcon } from '@helix/helix-icon/outlined'
import { useState } from 'react'
import { FilterLocations } from '../FilterLocations'
import { usePlatformClient } from '../usePlatformClient'
import { UsageStats } from './UsageStats'

export default function AdminUsageStats() {
  const { data: { currentUser } = {} } = useCurrentUser()
  const { data: { platformClient } = {} } = usePlatformClient({
    id: currentUser?.account?.id || ''
  })
  const tokens = getAccessTokens()

  const [locationFilter, setLocationFilter] = useState<{
    brokerageId?: string
    officeId?: string
  }>({})

  const downloadReportUrl = `${process.env.VITE_APP_CMA_URL}/admin/user_download_account/${platformClient?.id}?jwt=${tokens?.currentToken}`
  const downloadUsageReportUrl = `${process.env.VITE_APP_CMA_URL}/admin/user_download_account_report_counts/${platformClient?.id}?jwt=${tokens?.currentToken}`

  return (
    <div className="flex flex-col gap-5 md:max-h-[338px]">
      <header className="flex items-center justify-between">
        <div className="flex flex-col gap-1.5 md:flex-row md:items-center md:gap-4">
          <h2 className="helix-display-small">Usage</h2>
          <FilterLocations
            onChange={(selectedLocation) => {
              setLocationFilter({
                brokerageId:
                  selectedLocation?.value?.type === 'brokerage'
                    ? selectedLocation.value.id
                    : undefined,
                officeId:
                  selectedLocation?.value?.type === 'office'
                    ? selectedLocation.value.id
                    : undefined
              })
            }}
          />
        </div>
        <Menu button={<Button>Reports</Button>} direction="right">
          <Menu.Item
            as="a"
            href={`${downloadReportUrl}${
              locationFilter.brokerageId
                ? `&brokerage_id=${locationFilter.brokerageId}`
                : ''
            }${
              locationFilter.officeId
                ? `&office_id=${locationFilter.officeId}`
                : ''
            }&broker_agent_roaster=true`}>
            <div className="flex items-center gap-2">
              <HelixIcon icon={DocumentCSVIcon} />
              <div>
                <p className="text-gray-900">Download report</p>
              </div>
            </div>
          </Menu.Item>
          <Menu.Item
            as="a"
            href={`${downloadUsageReportUrl}${
              locationFilter.brokerageId
                ? `&brokerage_id=${locationFilter.brokerageId}`
                : ''
            }${
              locationFilter.officeId
                ? `&office_id=${locationFilter.officeId}`
                : ''
            }&broker_agent_roaster=true`}>
            <div className="flex items-center gap-2">
              <HelixIcon icon={DocumentCSVIcon} />
              <p className="text-gray-900">Download usage report</p>
            </div>
          </Menu.Item>
        </Menu>
      </header>
      <div>
        <UsageStats
          brokerageId={locationFilter.brokerageId}
          officeId={locationFilter.officeId}
        />
      </div>
    </div>
  )
}
